import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { genericQuantityField, genericUnitField } from './common/sharedFields';

export const intensityDenominatorCustomMetadata = {
  displayName: msg({
    message: 'Custom intensity denominator',
    context: 'Activity data schema name for custom intensity denominator',
  }),
  fields: {
    ...coreFields,
    intensity_denominator_kind: {
      displayName: msg({
        message: 'Intensity denominator kind',
        context: 'The display name for intensity_denominator_kind field',
      }),
      externalDescription: msg({
        message: 'The kind of intensity denominator.',
        context: 'Intensity denominator kind',
      }),
    },
    quantity: genericQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
